import React from "react";
import { Link } from "react-router-dom";

const items = [
  {
    img: "/assets/images/home-search.svg",
    title: "Pick Your Property",
    content: "Every home you see is already verified.",
  },
  {
    img: "/assets/images/card-check.svg",
    title: "Lock It In",
    content: "Submit your application and secure it fast. ",
  },
  {
    img: "/assets/images/secure-.svg",
    title: "Pay Safely",
    content: "Our trusted system protects your money.",
  },
  {
    img: "/assets/images/home-search-.svg",
    title: "Own With Confidence",
    content: "Get verified title documents and peace of mind.",
  },
];

const HowItWorks = () => {
  return (
    <div className="">
      <div className="lg:h-[480px] lg:px-20 lg:py-0 py-10 px-4 gap-8 flex flex-col items-center justify-center text-center text-white relative">
        <img
          src="/assets/images/hero.png"
          className="absolute top-0 w-full h-full object-cover left-0 z-[-1]"
          alt=""
        />
        <div className="max-w-[1160px] w-full flex items-center justify-center">
          <div className="flex flex-col items-center gap-1.5 md:gap-2.5">
            <h3 className="text-textWhite text-[28px] md:text-[36px] font-semibold">
              How It Works
            </h3>
            <span className="text-textWhite font-medium text-[14px] md:text-[18px]">
              Choose, Pay and Own
            </span>
          </div>
          <div className="hidden">
            <Link
              to={"/how-it-works"}
              className="py-[10px] px-[30px] text-primary font-semibold rounded-lg bg-textWhite hover:bg-textWhite/80 transition duration-300 uppercase shadow-custom border-primary"
            >
              see full process
            </Link>
          </div>
        </div>
        <div className="w-full grid-cols-1 grid  lg:grid-cols-4 items-center justify-center pt-8 lg:pt-2 pb-4 lg:pb-0 gap-16 lg:gap-8">
          {items.map((item, index) => (
            <div
              className="flex flex-col gap-3 lg:gap-6 px-5 items-center"
              key={index}
            >
              <div className="rounded-full size-20 lg:size-[100px] bg-[#F5F5F51A] items-center justify-center flex">
                <img src={item.img} className="size-14 lg:size-auto" alt="" />
              </div>
              <span className="font-semibold text-[22px] text-textWhite font-poppins">
                {item.title}
              </span>
              <span className="text-[16px] text-textWhite font-poppins">
                {item.content}
              </span>
            </div>
          ))}
        </div>
        <div className="md:hidden py-4 block">
          <Link
            to={"/how-it-works"}
            className="py-[10px] px-[30px] text-primary font-semibold rounded-lg bg-textWhite hover:bg-textWhite/80 transition duration-300 uppercase shadow-custom border-primary"
          >
            see full process
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
